document.addEventListener("DOMContentLoaded", () => {
    const boxesSections = document.querySelectorAll(".boxes");

    const alignHeights = () => {
        boxesSections.forEach((section) => {
            const items = section.querySelectorAll(".list__item");
            if (!items.length) return;

            items.forEach((item) => {
                const title = item.querySelector(".list__item-title");
                const text = item.querySelector(".list__item-text");
                if (title) title.style.height = "auto";
                if (text) text.style.height = "auto";
            });

            let maxTitleHeight = 0;
            let maxTextHeight = 0;

            items.forEach((item) => {
                const title = item.querySelector(".list__item-title");
                const text = item.querySelector(".list__item-text");

                if (title && title.offsetHeight > maxTitleHeight) {
                    maxTitleHeight = title.offsetHeight;
                }
                if (text && text.offsetHeight > maxTextHeight) {
                    maxTextHeight = text.offsetHeight;
                }
            });

            items.forEach((item) => {
                const title = item.querySelector(".list__item-title");
                const text = item.querySelector(".list__item-text");

                if (title) title.style.height = `${maxTitleHeight}px`;
                if (text) text.style.height = `${maxTextHeight}px`;
            });
        });
    };

    alignHeights();
    window.addEventListener("resize", alignHeights);
});